import { IdentityVerificationModalContent } from './IdentityVerificationModalContent';

export const IdentityVerificationModal = (): JSX.Element => (<IdentityVerificationModalContent />);
